// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__VgxsD","chatLink":"PrivacyPolicy_chatLink__GZK4N"};